export const PERMISSIONS = {
    ADMIN: 'admin',
    SUPER: 'admin-super',
    MEMBERS: 'members',
    EVENTS: 'events',
    TASKS: 'tasks',
    REQUESTS: 'requests',
    STATS: 'statistics',
    CORP: 'corporatedatabase',
    REIMB: 'reimbursements'
}
